export * from './data-table';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/md2/data-table/index.js
// module id = 869
// module chunks = 3